import { call, put, takeLatest } from 'redux-saga/effects';
import { YieldOf } from 'types/utils';
import { fetchedLatestCommunication, fetchLatestCommunication } from './actions';
import { logout } from '../api-auth/actions';
import getAPI from '../../api/iv-back';

type latestCommunicationActionPayload = ReturnType<typeof fetchLatestCommunication>;

function* LatestCommunicationSaga({ meta }: latestCommunicationActionPayload) {
  const { latestCommunication } = getAPI();
  const response: YieldOf<typeof latestCommunication> = yield call(latestCommunication, meta);
  const { data, ok, problem, status } = response;

  if (status === 401 || status === 403) {
    yield put(logout());
  }
  if (ok) {
    yield put(fetchedLatestCommunication(data));
  } else {
    const error = problem || 'unknown';
    yield put(fetchedLatestCommunication(undefined, error));
  }
}

export default function* LatestCommSaga() {
  yield takeLatest(fetchLatestCommunication.type, LatestCommunicationSaga);
}
